@let scans = (scannerService.scans$ | async) ?? [];
@let isScannerLoading = scannerService.scannerLoadingStatus() === LoadingState.LOADING;
@let isScannerLoaded = scannerService.scannerLoadingStatus() === LoadingState.READY;
@let scannerTotalCount = scannerService.scannerTotalCount();

<section class="scanner page-viewport">
  <mon-page-toolbar
    titleTranslateKey="monitoring.menu.scanner"
    [actions]="toolbarActions"
    [selectedFiltersCount]="selectedFiltersCount"
    (actionClick)="onToolbarAction($event)"
  >
    <div
      toolbarInlineControls
      class="toolbar-date-picker--icon-only"
      [formGroup]="scannerFormFilters"
    >
      <lib-date-picker
        class="scanner-filters__date-picker"
        placeholderTranslateKey="monitoring.select-date"
        formControlName="datePeriod"
      />
    </div>

    <div
      toolbarFilters
      class="scanner-filters"
      [formGroup]="scannerFormFilters"
    >
      <div class="scanner-filters__container">
        @if (canReadFacilities()) {
          <mon-facility-select
            formControlName="facilityId"
            [fullWidth]="true"
            labelTranslateKey="monitoring.scanner.facility"
            class="scanner-filters__facility"
          />
        }
      </div>
    </div>

    @if (isFiltersActive) {
      <div toolbarSelectedFilters>
        <lib-button
          (click)="clearAllFilters()"
          class="chip chip--button"
          buttonStyle="danger"
          buttonSize="medium"
          buttonType="button"
        >
          <span> {{ 'monitoring.clear-filters' | translate }} </span>
        </lib-button>
      </div>
    }
  </mon-page-toolbar>

  <section class="page-content page-table page-table-scroll">
    <div class="page-table-scroll__content">
      <lib-table
        class="page-table-scroll__table scanner__table"
        trCustomClass="desktop-table-row--hoverable"
        [columns]="SCANNER_COLUMNS"
        [dataSource]="scans"
        [cellTemplates]="{
          facility: facilityTpl,
          containersCount: containersCountTpl,
          scanResultsCount: scanResultsCountTpl,
          createdByUser: createdByUserTpl,
          status: statusTpl,
          createdDate: createdDateTpl,
        }"
        [loaded]="isScannerLoaded"
        [loading]="isScannerLoading"
        (desktopRowClick)="openDetails($event.id)"
      />
    </div>

    @if (!(scans.length === 0 && currentPage() === 1)) {
      <lib-pagination
        [totalCount]="scannerTotalCount"
        [pageIndex]="currentPage()"
        [pageSize]="100"
        [loading]="isScannerLoading"
        (paginationChange)="onPageChange($event)"
      />
    }
  </section>

  <ng-template
    #facilityTpl
    let-row="data"
  >
    @let data = asSearchScan(row);
    <div class="scanner__cell">{{ data.facility.name }}</div>
  </ng-template>

  <ng-template
    #containersCountTpl
    let-row="data"
  >
    @let data = asSearchScan(row);
    <div class="scanner__cell">{{ data.containersCount }}</div>
  </ng-template>

  <ng-template
    #scanResultsCountTpl
    let-row="data"
  >
    @let data = asSearchScan(row);
    <div class="scanner__cell">{{ data.scanResultsCount }}</div>
  </ng-template>

  <ng-template
    #createdByUserTpl
    let-row="data"
  >
    @let data = asSearchScan(row);
    <div class="scanner__cell scanner__created-by">
      <div>{{ data.createdByUser.firstName }}</div>
      <div>{{ data.createdByUser.lastName }}</div>
    </div>
  </ng-template>

  <ng-template
    #statusTpl
    let-row="data"
  >
    @let status = asSearchScan(row).status;
    @let badge = getScanStatusBadge(status.id);

    <div class="scanner__cell">
      <span
        class="scanner__badge"
        [ngClass]="badge.modifier ? 'scanner__badge--' + badge.modifier : null"
      >
        {{ badge.key | translate }}
      </span>
    </div>
  </ng-template>

  <ng-template
    #createdDateTpl
    let-row="data"
  >
    @let data = asSearchScan(row);
    <div class="scanner__cell">{{ data.createdDate | date: 'medium' }}</div>
  </ng-template>
</section>
